import { IntegrationDataType } from '@mews-commander/data-access';
import { FeatureFlag } from '@mews-commander/enums';
import { FeatureFlagServiceProps } from '@mews/framework';
import { createHandler } from '@mews/std';
import { CzechPoliceExportIntegrationUpdateForm } from './czechPoliceExportIntegration';
import { IstatAbruzzoExportIntegrationUpdateForm } from './istatAbruzzoExportIntegration';
import { IstatCalabriaExportIntegrationUpdateForm } from './istatCalabriaExportIntegration';
import { MewsBIIntegrationUpdateForm } from './mewsBIIntegration';

type ComponentValueHandler = (data: FeatureFlagServiceProps) => React.FC | null;

const handlerMap = {
    [IntegrationDataType.CzechPoliceExportIntegration]: ({ featureFlagService }) =>
        featureFlagService.hasFlag(FeatureFlag.marketplaceCzechPoliceExportIntegrationUpdateFormEnabled)
            ? CzechPoliceExportIntegrationUpdateForm
            : null,
    [IntegrationDataType.IstatAbruzzoExportIntegration]: () => IstatAbruzzoExportIntegrationUpdateForm,
    [IntegrationDataType.IstatCalabriaExportIntegration]: () => IstatCalabriaExportIntegrationUpdateForm,
    [IntegrationDataType.MewsBiIntegration]: () => MewsBIIntegrationUpdateForm,
} satisfies Partial<Record<IntegrationDataType, ComponentValueHandler>>;

export const updateComponentHandler = createHandler<IntegrationDataType, ComponentValueHandler>(handlerMap, () => null);
